import React from "react";
import { Typography } from "antd";
import { baseURL } from "../../globalUtils/axiosConfig";

const { Title } = Typography;

const TermReportTable = ({ data, streams, report_type, report_period }) => {
  const {
    user = {},
    teachers = [],
    class: classInfo = {},
    report_log = {},
  } = data || {};

  const {
    first_name = "",
    last_name = "",
    year_level = "",
    login_id = "",
    image_path = "",
  } = user || {};

  const fullName = `${first_name} ${last_name}`;

  const pageStyle = {
    position: "relative",
    width: "100%",
    maxWidth: "210mm",
    minHeight: "297mm",
    background: "white",
    margin: "5px auto",
    fontFamily: "Arial, sans-serif",
    color: "#333",
    boxSizing: "border-box",
    border: "1px solid #ccc",
    background: "#f9f9f9",
    marginBottom: "20px",
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  return (
    <>
      <div style={pageStyle} className="pdf-page" >
        <div
          style={{
            marginBottom: "15px",
            padding: "8px",
            maxWidth: "210mm",
          }}
        >
          <div style={{ position: "absolute", top: "20mm", right: "20mm" }}>
            <img
              src="/apple-touch-icon.png"
              alt="Alsiraat"
              style={{ width: "120px" }}
            />
          </div>

          <div style={{ textAlign: "center", marginBottom: "40px" }}>
            <h1 style={{ fontSize: "32px", fontWeight: "bold", color: "#222", marginTop: "20px" }}>
              {(report_log?.report_type || "TERM").toUpperCase()}
            </h1>
            <h2 style={{ fontSize: "20px", marginTop: "5px", color: "#777" }}>
              {report_period || "Report Period"}
            </h2>
            <h2 style={{ fontSize: "24px", marginTop: "10px", color: "#555" }}>
              {classInfo?.name ? `${classInfo.name} - ${classInfo.code}` : "CLASS"}
            </h2>
            <h3 style={{ fontSize: "20px", marginTop: "20px", color: "#555" }}>
              {fullName}
            </h3>
            <p>
              <strong>Student ID:</strong> {login_id}
            </p>
            <p>
              <strong>YEAR LEVEL:</strong> {year_level}
            </p>
            <p>
              <strong>Start Date:</strong>{" "}
              {formatDate(report_log?.metadata?.start_date)}
            </p>
            <p>
              <strong>End Date:</strong>{" "}
              {formatDate(report_log?.metadata?.end_date)}
            </p>
            <p>
              <strong>TEACHER{teachers.length > 1 ? "S" : ""}:</strong>{" "}
              {teachers.map((t) => t.name).join(", ")}
            </p>
          </div>

          <div style={{ fontSize: "16px", marginTop: "20px", lineHeight: 1.5 }}>
            <img
              src={image_path ? `${baseURL}/${image_path}` : "/download.png"}
              alt="profile"
              style={{
                width: "120px",
                marginBottom: "30px",
                backgroundColor: "transparent",
                mixBlendMode: "multiply",
                position: "absolute",
                top: "20mm",
                left: "20mm",
              }}
            />
          </div>
        </div>
      </div>

      {streams.map((stream) =>
        stream.learning_activities?.map((activity) =>
          activity.curriculums?.map((item, index) => {
            const {
              curriculum = {},
              runtime_competency_rate = 0,
              homework_rate = 0,
              parent_engagement_rate = 0,
              pending_homework = 0,
              submitted_homework = 0,
              verified_homework = 0,
              total_homework = 0,
              profile_risk = "",
              progress_status = "",
              status = "",
              overall_summary = {},
              all_attempts = []
            } = item;

            const categoryTotal = Object.fromEntries(
              Object.entries(overall_summary).map(([key, values]) => [
                key,
                Object.values(values).reduce((sum, value) => sum + value, 0)
              ])
            );

            const result = Object.values(
              all_attempts.reduce((acc, attempt) => {
                attempt.summary.forEach((item) => {
                  const { _id, name } = item.observation;
            
                  if (!acc[_id]) {
                    acc[_id] = {
                      _id,
                      observation_name: name,
                      observed_count: 0,
                      performance_sum: 0,
                      total_observations: 0,
                    };
                  }
            
                  acc[_id].observed_count += item.observed_count;
                  acc[_id].performance_sum += item.performance;
                  acc[_id].total_observations += 1;
                });
            
                return acc;
              }, {})
            ).map((item) => ({
              ...item,
              average_performance:
                item.total_observations > 0
                  ? item.performance_sum / item.total_observations
                  : 0,
            }));

            return (
              <div
                key={item._id || index}
                className="pdf-page"
                style={{
                  width: "210mm",
                  minHeight: "297mm",
                  padding: "8mm",
                  margin: "0 auto 15px auto",
                  background: "#fff",
                  border: "1px solid #ccc",
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  pageBreakAfter: "always",
                  overflow: "hidden",
                }}
              >
                <div style={{
                  display: "flex", flexDirection: "column", gap: "10px", marginBottom: "10px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "10px",
                  padding: "8px",
                  background: "#f9f9f9",
                }}>
                  <Title level={3} style={{ color: "#50B6F2", margin: 0 }}>
                    {activity.name}
                  </Title>

                  <div
                    style={{
                      background: "#fff",
                      borderRadius: "8px",
                      padding: "8px",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                      breakInside: "avoid",
                      pageBreakInside: "avoid",
                    }}
                  >
                    <Title level={4} style={{ color: "#50B6F2", margin: "0 0 6px 0" }}>
                      {curriculum?.name || "Curriculum"}{" "}
                      {curriculum?.nominal_year_level ? `(Level ${curriculum.nominal_year_level})` : ""}
                    </Title>

                    <div
                      style={{
                        background: "#f2f2f2",
                        padding: "10px",
                        fontSize: "12px",
                        breakInside: "avoid",
                        pageBreakInside: "avoid",
                      }}
                    >
                      <b style={{ color: "#50B6F2" }}>Subject Outline</b>
                      <p style={{ textAlign: "justify" }}>
                        In <b>{report_period}</b>, students improved various skills related to <b>{curriculum?.name}</b> through engaging lessons and assessments.
                      </p>
                    </div>


                    <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", breakInside: "avoid", pageBreakInside: "avoid" }}>
                      <div style={{ flex: 1 }}>
                        <h4 style={{ marginBottom: "2px", fontWeight: "bold" }}>Academic Performance</h4>
                        <table style={{ width: "100%", fontSize: "12px" }}>
                          <tbody>
                            <tr><td>1. Competency Rate</td><td>{runtime_competency_rate.toFixed(2)}%</td></tr>
                            <tr><td>2. Homework Rate</td><td>{homework_rate}%</td></tr>
                            <tr><td>3. Parent Engagement Rate</td><td>{parent_engagement_rate}%</td></tr>
                            <tr><td>4. Profile Risk</td><td style={{ color: profile_risk === "high" ? "#FF1A1A" : profile_risk === "medium" ? "#F3CC00" : "#00CE08", fontWeight: "bold" }}>{profile_risk && profile_risk.charAt(0).toUpperCase() + profile_risk.slice(1).toLowerCase()}</td></tr>
                            <tr><td>5. Progress Status</td><td>{progress_status}</td></tr>
                            <tr><td>6. Curriculum Status</td><td>{status ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase() : "-"}</td></tr>
                          </tbody>
                        </table>
                      </div>

                      <div style={{ flex: 1 }}>
                        <h4 style={{ marginBottom: "2px", fontWeight: "bold" }}>Homework Progress</h4>
                        <table style={{ width: "100%", fontSize: "12px" }}>
                          <tbody>
                            <tr><td>1. Submitted Homework</td><td>{submitted_homework}</td></tr>
                            <tr><td>2. Verified Homework</td><td>{verified_homework}</td></tr>
                            <tr><td>3. Pending Homework</td><td>{pending_homework}</td></tr>
                            <tr><td>4. Total Homework</td><td>{total_homework}</td></tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    {result.length > 0 && (
                      <div
                        style={{
                          marginTop: "10px",
                          border: "1px solid #ddd",
                          borderRadius: "8px",
                          padding: "10px",
                          background: "#fff",
                          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                          breakInside: "auto",
                          pageBreakInside: "auto",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                            marginBottom: "8px",
                          }}
                        >
                          <h4
                            style={{
                              margin: 0,
                              color: "#50B6F2",
                            }}
                          >
                            Observations:
                          </h4>
                        </div>

                        {result.map(
                          (item, idx) => {
                            const { observation_name, observed_count, average_performance } = item;
                            
                            // Performance is out of 10
                            const performancePercentage = (average_performance / 10) * 100;

                            return (
                              <div
                                key={idx}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "12px",
                                  marginBottom: "6px",
                                  gap: "6px",
                                }}
                              >
                                {/* Observation name + observed count */}
                                <div
                                  style={{
                                    width: "150px",
                                    flexShrink: 0,
                                    fontWeight: "500",
                                  }}
                                >
                                  {observation_name} ({observed_count})
                                </div>

                                {/* Separator */}
                                <div
                                  style={{
                                    width: "1px",
                                    background: "#ccc",
                                    height: "14px",
                                    flexShrink: 0,
                                  }}
                                />

                                {/* Progress bar */}
                                <div
                                  style={{
                                    flex: 1,
                                    height: "12px",
                                    background: "#f0f0f0",
                                    borderRadius: "2px",
                                    overflow: "hidden",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: `${performancePercentage}%`,
                                      background: "#50B6F2",
                                      height: "100%",
                                      borderRadius: "2px",
                                    }}
                                  />
                                </div>

                                {/* Percentage */}
                                <div
                                  style={{
                                    minWidth: "42px",
                                    textAlign: "right",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {performancePercentage.toFixed(0)}%
                                </div>
                              </div>
                            );
                          }
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        )
      )}
    </>
  );
};

export default TermReportTable;
